import React from "react";
import { Card, Button, Tag, Avatar } from "antd";
import {
    EditOutlined,
    DeleteOutlined,
    UserOutlined,
    GlobalOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    MailOutlined
} from "@ant-design/icons";
import { cn } from "../../../../utils/cn";

const EnhancedLeadSourceGridView = ({
    record,
    actions = [],
    onCardClick,
}) => {

    // Filter actions based on conditions
    const filteredActions = actions
        .map((action) => {
            if (action.condition && !action.condition(record)) {
                return null;
            }
            return action;
        })
        .filter(Boolean);

    return (
        <Card
            hoverable
            className="h-full cursor-pointer"
            onClick={() => onCardClick(record)}
        >
            <div className="space-y-4">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-3 min-w-0">
                        <Avatar
                            size={48}
                            className="flex-shrink-0 font-semibold text-lg !bg-primary"
                            icon={<GlobalOutlined />}
                        />
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-base mb-1 truncate text-primary" title={record.jobName}>
                                {record.jobName || "N/A"}
                            </h3>
                            <Tag color="cyan">{record.leadSource}</Tag>
                        </div>
                    </div>
                </div>

                {/* Info */}
                <div className="space-y-3 border-b border-gray-200 pb-3">
                    {/* Username/Email */}
                    <div className="flex items-center text-sm text-gray-600">
                        <MailOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate" title={record.username}>
                            {record.username}
                        </span>
                    </div>

                    {/* Active Status */}
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-600 font-medium">
                            Status:
                        </span>
                        <Tag
                            icon={record.active ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                            color={record.active ? 'success' : 'error'}
                        >
                            {record.active ? 'Active' : 'Inactive'}
                        </Tag>
                    </div>
                </div>

                {/* Action Buttons */}
                {filteredActions.length > 0 && (
                    <div
                        className={cn(
                            "grid gap-2 pt-1.5",
                            filteredActions.length === 1 ? "grid-cols-1" : "grid-cols-2"
                        )}
                    >
                        {filteredActions.map((action, idx) => (
                            <Button
                                key={idx}
                                title={action.title ?? action.label}
                                className={cn(
                                    "text-sm font-medium h-9 my-1 !border-primary !text-primary hover:!bg-primary hover:!text-white !min-w-full flex justify-center items-center transition-colors duration-150 ease-in-out",
                                    action.className
                                )}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    action.onClick(record);
                                }}
                            >
                                {action.icon &&
                                    React.cloneElement(action.icon, { className: "mr-2" })}
                                {action.label}
                            </Button>
                        ))}
                    </div>
                )}
            </div>
        </Card>
    );
};

export default EnhancedLeadSourceGridView;
